// Module
var code = "<p>Enable this setting to display percentages instead absolute numbers of participants.</p> ";
// Exports
module.exports = code;